import {loginDy, getKsAccoutInfo, moLogin, douyuLogin} from '../api/api';
export const toastTips = (msg, time)=> {
    const _toastTips = document.getElementsByClassName('ToastTips');
    if(_toastTips.length > 0) return;
    const _img = require('../assets/images/error.png');
    console.log(_img);
    const _html = `<div class="toast-box">
            <img src="${_img}">
            <span>${msg}</span>
        </div>`;

    let div = document.createElement('div');
    div.className = 'ToastTips';
    div.innerHTML = _html;
    document.body.appendChild(div);

    setTimeout(()=> {
        document.body.removeChild(div);
    }, time || 3000);
}




export const bussData = {
    dy: {
        name: '抖音',
        title: 'DY · 钻石 · 全网低价',
        type: 'dy',
        orderType: 60,
        unit: '钻',
        itemName: '钻石',
        payTitle: '钻石充值', // 支付详情商品名称
        iconImg: require('../assets/images/douyin.jpg'),
        serviceLink: 'https://work.weixin.qq.com/kfid/kfca394c4b30b34224f',
        reqUserInfo: (id, callBack, errorBack)=> {
            loginDy(id).then(res => {
                const {code, data, msg} = res
                if(code === 200 && Array.isArray(data) && data.length > 0) {
                    const reqUserInfo = data[0];
                    const {nick_name, avatar_thumb: {url_list}} = reqUserInfo;
                    var uObj = {
                      nickName: nick_name, 
                      headImg: url_list[0],
                      userId: id,
                    }
                    localStorage.setItem('dy', JSON.stringify(uObj))


                    if(callBack) {
                      callBack(uObj);
                    }
                  } else {
                    toastTips(msg);
                    if(errorBack) errorBack()
                }
            })
        },
        chargeAgreement: [
            '1、钻石用于抖音APP内直播间礼物打赏，非抖+，无法加热视频。',
            '2、付款后钻石实时到账，充值成功后无法进行退款操作。',
            '3、根据文化部规定，购买网游类商品必须年满18周岁。未成年人不得使用本充值服务。',
            '4、近期不法分子以恶劣的方式进行网络电信诈骗，平台郑重提示你，请勿为他人进行充值，为他人进行充值所产生的损失由用户自行承担。',
            '5、本平台为第三方优惠渠道，非官方，请知晓。',
        ]
    },
    ks: {
        name: '快手',
        title: '快手 · 快币 · 全网低价',
        unit: '快币',
        itemName: '快手币',
        type: 'ks',
        orderType: 61,
        payTitle: '快币充值',
        iconImg: require('../assets/images/kuaishou.png'),
        serviceLink: 'http://awt.zoosnet.net/LR/Chatpre.aspx?id=AWT87895608&lng=cn',
        reqUserInfo: (id, callBack, errorBack)=> {
            getKsAccoutInfo(id).then(res => {
                const {result, headUrl: headImg, userName: nickName, userId, error_msg} = res;
                if(result === 1) {
                    var uObj = {
                        nickName, 
                        headImg,
                        userId: id,
                    }
                    localStorage.setItem('ks', JSON.stringify(uObj))
                    if(callBack) {
                        callBack(uObj);
                    }
                }
                else {
                    toastTips(error_msg || '无法识别快手号');
                    if(errorBack) errorBack()
                }
            })
        },
        chargeAgreement: [
            '1、付款后实时到账，充值成功后无法进行退款操作。',
            '2、根据文化部规定，购买网游类商品必须年满18周岁。未成年人不得使用本充值服务。',
            '3、近期不法分子以恶劣的方式进行网络电信诈骗，平台郑重提示你，请勿为他人进行充值，为他人进行充值所产生的损失由用户自行承担。',
            '4、本平台为第三方优惠渠道，非官方。',
        ]
    },
    huya: {
        name: '虎牙',
        title: '虎牙 · 虎牙币 · 全网低价',
        unit: '虎牙币',
        itemName: '虎牙币',
        type: 'huya',
        orderType: 63,
        payTitle: '虎牙币充值',
        accoutHelpTips: '虎牙号',
        accoutHelpImg: require('../assets/images/huya_help.jpg'),
        iconImg: require('../assets/images/huya.png'),
        serviceLink: 'http://awt.zoosnet.net/LR/Chatpre.aspx?id=AWT87895608&lng=cn',
        reqUserInfo: (id, callBack, errorBack)=> {
            var uObj = {
            nickName: '', 
            headImg: '',
            userId: id,
            }
            localStorage.setItem('huya', JSON.stringify(uObj))
            if(callBack) {
            callBack(uObj);
            }
        },
        chargeAgreement: [
            '1、付款后实时到账，充值成功后无法进行退款操作。',
            '2、根据文化部规定，购买网游类商品必须年满18周岁。未成年人不得使用本充值服务。',
            '3、近期不法分子以恶劣的方式进行网络电信诈骗，平台郑重提示你，请勿为他人进行充值，为他人进行充值所产生的损失由用户自行承担。',
            '4、本平台为第三方优惠渠道，非官方。',
        ]
    },
    douyu: {
        name: '斗鱼',
        title: '斗鱼 · 斗鱼鱼翅 · 全网低价',
        unit: '斗鱼鱼翅',
        itemName: '斗鱼鱼翅',
        type: 'douyu',
        orderType: 62,
        payTitle: '斗鱼鱼翅充值',
        inputPlaceHolder: '请填写正确的斗鱼昵称',
        accoutHelpTips: '斗鱼昵称',
        accoutHelpImg: require('../assets/images/douyu_help.jpg'),
        iconImg: require('../assets/images/douyu.png'),
        serviceLink: 'http://awt.zoosnet.net/LR/Chatpre.aspx?id=AWT87895608&lng=cn',
        reqUserInfo: (id, callBack, errorBack)=> {
            douyuLogin(id).then(res => {
                if(res.code === 200) {
                    const data = res.data
                   var uObj = {
                        nickName: data.nickName, 
                        headImg: data?.avatar,
                        userId: id,
                    }
                    localStorage.setItem('douyu', JSON.stringify(uObj))
                    if(callBack) {
                        callBack(uObj);
                    } 
                } else {
                    toastTips(res.msg || '无法识别此账号');
                    if(errorBack) errorBack()
                }
            })


        },
        chargeAgreement: [
            '1、付款后实时到账，充值成功后无法进行退款操作。',
            '2、根据文化部规定，购买网游类商品必须年满18周岁。未成年人不得使用本充值服务。',
            '3、近期不法分子以恶劣的方式进行网络电信诈骗，平台郑重提示你，请勿为他人进行充值，为他人进行充值所产生的损失由用户自行承担。',
            '4、本平台为第三方优惠渠道，非官方。',
        ]
    },
    momo: {
        name: '陌陌',
        title: '陌陌 · 陌陌币· 全网低价',
        unit: '陌陌币',
        itemName: '陌陌币',
        type: 'momo',
        orderType: 67,
        payTitle: '陌陌币充值',
        iconImg: require('../assets/images/momo.png'),
        serviceLink: 'http://awt.zoosnet.net/LR/Chatpre.aspx?id=AWT87895608&lng=cn',
        reqUserInfo: (id, callBack, errorBack)=> {
            moLogin(id).then(res => {
                if(res.code === 200) {
                    const data = res.data
                   var uObj = {
                        nickName: data.nickName, 
                        headImg: data?.avatar,
                        userId: id,
                    }
                    localStorage.setItem('momo', JSON.stringify(uObj))
                    if(callBack) {
                        callBack(uObj);
                    } 
                } else {
                    toastTips(res.msg || '无法识别此账号');
                    if(errorBack) errorBack()
                }
            })
        },

        chargeAgreement: [
            '1、付款后实时到账，充值成功后无法进行退款操作。',
            '2、根据文化部规定，购买网游类商品必须年满18周岁。未成年人不得使用本充值服务。',
            '3、近期不法分子以恶劣的方式进行网络电信诈骗，平台郑重提示你，请勿为他人进行充值，为他人进行充值所产生的损失由用户自行承担。',
            '4、本平台为第三方优惠渠道，非官方。',
        ]
    },
    tantan: {
        name: '探探',
        title: '探探 · 探探币· 全网低价',
        unit: '探探币',
        itemName: '探探币',
        type: 'tantan',
        orderType: 64,
        payTitle: '探探币充值',
        iconImg: require('../assets/images/tantan.png'),
        serviceLink: 'http://awt.zoosnet.net/LR/Chatpre.aspx?id=AWT87895608&lng=cn',
        reqUserInfo: (id, callBack, errorBack)=> {
            var uObj = {
                nickName: '', 
                headImg: '',
                userId: id,
            }
            localStorage.setItem('tantan', JSON.stringify(uObj))
            if(callBack) {
                callBack(uObj);
            }
        },
        chargeAgreement: [
            '1、付款后实时到账，充值成功后无法进行退款操作。',
            '2、根据文化部规定，购买网游类商品必须年满18周岁。未成年人不得使用本充值服务。',
            '3、近期不法分子以恶劣的方式进行网络电信诈骗，平台郑重提示你，请勿为他人进行充值，为他人进行充值所产生的损失由用户自行承担。',
            '4、本平台为第三方优惠渠道，非官方。',
        ]
    },
    redBook: {
        name: '小红书',
        title: '小红书 · 薯币 · 全网低价',
        type: 'redBook',
        orderType: 65,
        unit: '薯币',
        itemName: '薯币',
        payTitle: '薯币充值', // 支付详情商品名称
        iconImg: require('../assets/images/redBook.png'),
        serviceLink: 'http://awt.zoosnet.net/LR/Chatpre.aspx?id=AWT87895608&lng=cn',
        
        reqUserInfo: (payload, callBack, errorBack)=> {
            
            // accoutLogin(payload).then(res => {
            //     const {code, data, msg} = res
            //     if(code === 200) {
            //         var uObj = {
            //             nickName: '', 
            //             headImg: '',
            //             userId: payload.accountNumber
            //         }
            //         localStorage.setItem('redBook', JSON.stringify(uObj))
                    


            //         if(callBack) {
            //           callBack(uObj);
            //         }
            //       } else {
            //         toastTips(msg);
            //         if(errorBack) errorBack()
            //     }
            //})
        },
        chargeAgreement: [
            '1、薯币用于小红书APP内直播间礼物打赏。',
            '2、付款后薯币实时到账，充值成功后无法进行退款操作。',
            '3、根据文化部规定，购买网游类商品必须年满18周岁。未成年人不得使用本充值服务。',
            '4、近期不法分子以恶劣的方式进行网络电信诈骗，平台郑重提示你，请勿为他人进行充值，为他人进行充值所产生的损失由用户自行承担。',
            '5、本平台为第三方优惠渠道，非官方，请知晓。',
        ]
    },
    bi: {
        name: 'B站',
        title: 'B站 · 电池 · 全网低价',
        type: 'bi',
        orderType: 66,
        unit: '电池',
        itemName: '电池',
        payTitle: '电池充值', // 支付详情商品名称
        iconImg: require('../assets/images/bibi.png'),
        serviceLink: 'http://awt.zoosnet.net/LR/Chatpre.aspx?id=AWT87895608&lng=cn',
        reqUserInfo: (payload, callBack, errorBack)=> {
        },
        chargeAgreement: [
            '1、电池用于B站APP内直播间礼物打赏。',
            '2、付款后电池实时到账，充值成功后无法进行退款操作。',
            '3、根据文化部规定，购买网游类商品必须年满18周岁。未成年人不得使用本充值服务。',
            '4、近期不法分子以恶劣的方式进行网络电信诈骗，平台郑重提示你，请勿为他人进行充值，为他人进行充值所产生的损失由用户自行承担。',
            '5、本平台为第三方优惠渠道，非官方，请知晓。',
        ]
    }
}



// 本地缓存登录账号信息
/*
*dyDataObj = {
   userId: searchId,
    headImg: headImg || '',
    nickName: nickName || '',
}
*/
export const setStorage = (dyDataObj, type)=> {
    localStorage.setItem((type === 'douyin' ? 'dyData' : 'ksData'), JSON.stringify(dyDataObj));
  }